import { render, staticRenderFns } from "./TeamBioData.vue?vue&type=template&id=85e57d78&"
import script from "./TeamBioData.vue?vue&type=script&lang=js&"
export * from "./TeamBioData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports